export default __webpack_public_path__ + "fonts/axure_icon.1494f59f5ae3f56a0c39a9f41294ff1c.png";